module.exports = __webpack_public_path__ + "img/status-cancelled.fc3c7069.svg";